import Response from "./Response";

const TaskBoard = {
    init() {
        $(document).on("click", "[data-task-assignee]", function () {
            const option = $(this);
            const picker = option.closest(".task-item__assignee-picker");
            const options = picker.find("[data-task-assignee]");
            const data = { assignee: option.attr("data-assignee") };
            data[yii.getCsrfParam()] = yii.getCsrfToken();

            options.prop("disabled", true);
            picker.attr("aria-busy", "true");
            $.post(option.data("url"), data)
                .done((response) => {
                    Response.handle(response);
                })
                .fail((xhr) => {
                    Response.error(xhr);
                })
                .always(() => {
                    options.prop("disabled", false);
                    picker.removeAttr("aria-busy");
                });
        });

        $(document).on("change", "[data-task-toggle]", function () {
            const checkbox = $(this);
            const previousState = !checkbox.prop("checked");
            const taskId = checkbox.closest("[data-task-id]").data("task-id");
            const taskInstances = $(`[data-task-id="${taskId}"]`);
            const checkboxes = taskInstances.find("[data-task-toggle]");
            checkboxes.prop("disabled", true).attr("aria-busy", "true");

            $.post(checkbox.data("url"))
                .done((response) => {
                    if (!response.status) {
                        checkboxes.prop("checked", previousState);
                        return Response.handle(response);
                    }

                    const done = Number(response.taskStatus) === 20;
                    checkboxes.prop("checked", done).closest("label").attr("title", done ? "Przywróć zadanie" : "Oznacz zadanie jako wykonane");
                    taskInstances.each(function () {
                        const task = $(this);
                        const collection = task.closest("[data-task-collection]");
                        task.toggleClass("task-item--done", done);
                        task.toggleClass("task-item--overdue", !done && Number(task.data("task-overdue")) === 1);

                        if (done) {
                            collection.find("[data-task-empty]").before(task);
                        } else {
                            const firstDone = collection.children(".task-item--done").first();
                            if (firstDone.length) firstDone.before(task);
                            else collection.find("[data-task-empty]").before(task);
                        }
                    });
                })
                .fail((xhr) => {
                    checkboxes.prop("checked", previousState);
                    Response.error(xhr);
                })
                .always(() => checkboxes.prop("disabled", false).removeAttr("aria-busy"));
        });

        $(document).on("pointerdown", "[data-task-drag]", function (event) {
            if (event.pointerType === "mouse" && event.button !== 0) return;

            const handle = this;
            const item = $(handle).closest("[data-task-id]");
            const container = item.closest("[data-task-sortable]");
            const originalOrder = TaskBoard.order(container);
            const pointerId = event.pointerId;

            event.preventDefault();
            handle.setPointerCapture(pointerId);
            item.addClass("is-dragging");
            $(document.body).addClass("is-sorting-tasks");

            $(document).on("pointermove.task-sort", function (moveEvent) {
                if (moveEvent.pointerId !== pointerId) return;
                const target = $(document.elementFromPoint(moveEvent.clientX, moveEvent.clientY)).closest("[data-task-id]");
                if (!target.length || target[0] === item[0] || target.closest("[data-task-sortable]")[0] !== container[0]) return;

                const bounds = target[0].getBoundingClientRect();
                if (moveEvent.clientY < bounds.top + bounds.height / 2) target.before(item);
                else target.after(item);
            });

            $(document).one("pointerup.task-sort pointercancel.task-sort", function (upEvent) {
                if (upEvent.pointerId !== pointerId) return;
                $(document).off("pointermove.task-sort");
                item.removeClass("is-dragging");
                $(document.body).removeClass("is-sorting-tasks");

                const order = TaskBoard.order(container);
                if (order.join(",") === originalOrder.join(",")) return;

                $.post(container.data("sort-url"), { order })
                    .fail((xhr) => {
                        const emptyState = container.find("[data-task-empty]");
                        originalOrder.forEach((id) => emptyState.before(container.find(`[data-task-id="${id}"]`)));
                        Response.error(xhr);
                    });
            });
        });
    },

    order(container) {
        return container.find("[data-task-id]").map(function () {
            return Number($(this).data("task-id"));
        }).get();
    },
};

export default TaskBoard;
